var map = {
	"./Architekt AI.png": 6150,
	"./CloudZee.png": 8706,
	"./Hodo.png": 4991,
	"./HodoBW.png": 1142,
	"./InstantSS.png": 358,
	"./Nutrifit.png": 1364,
	"./Rapid Hospitals.png": 7692,
	"./Research Simplified.png": 996,
	"./Stavya.png": 5829,
	"./Z-Bot.png": 8581,
	"./cloudzee2.png": 4154,
	"./hodo2.png": 7869,
	"./hodonew.png": 2997,
	"./instantss2.png": 3382,
	"./stavya2.png": 6115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8746;